import { render } from "./SendEmailInvoiceAttachmentsSection.vue?vue&type=template&id=5f919202"
import script from "./SendEmailInvoiceAttachmentsSection.vue?vue&type=script&lang=js"
export * from "./SendEmailInvoiceAttachmentsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__